'use client';
import * as React from 'react';
import { CRModal } from '@coverright/ui/shared/crmodal';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { X } from '@phosphor-icons/react/dist/ssr/X';
import { CalendlyCallType, CalendlyProps } from '../lib/types';
import { Calendly } from './calendly';
import { getDisclamers } from '@coverright/utils';
import { useState } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

export interface ModalProps extends Partial<CalendlyProps> {
  onClose: (value: boolean) => void;
  width?: number | string;
  open?: boolean;
  logEvent?: (message: string, data?: any) => void;
  subtitle?: string;
}

export const CalendlyModal = (props: ModalProps) => {
  const { width, logEvent, subtitle, ...rest } = props;
  const [eventScheduled, setEventScheduled] = useState(false);

  React.useEffect(() => {
    if (logEvent && props.open !== false) {
      logEvent('Calendly modal opened');
      setEventScheduled(false);
    }
  }, [props.open, logEvent]);

  const onClose = (val: boolean) => {
    logEvent && logEvent('Calendly modal closed', { scheduled: val });
    props.onClose(val);
  };

  return (
    <CRModal
      slotProps={{
        backdrop: {
          sx: {
            background: 'rgba(0, 0, 0, 0.25)'
          }
        }
      }}
      sx={{zIndex: 1600}}
      paperSx={{overflowY: 'hidden', background: '#FFF'}}
      width={width || 725}
      id={'calendly-modal'}
      paperPadding={0}
      open={props.open === undefined ? true : props.open}
      onClose={() => onClose(eventScheduled)}
    >
      <Stack>
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ ml: 4, my: 1, mr: 1 }}>
          <Typography  sx={{ fontSize: 20, lineHeight: 1.3, fontWeight: 500 }}>
            Schedule a call
          </Typography>

          <IconButton
            data-test="modal-close-button"
            sx={{alignSelf: 'flex-end'}}
            onClick={() => onClose(eventScheduled)}
          >
            <X size={24} color="#000" />
          </IconButton>
        </Stack>

        <OverlayScrollbarsComponent style={{ maxHeight: '700px' }} options={{ paddingAbsolute: true, scrollbars: { autoHide: 'move' } }} defer>
          <Stack>
            <Typography sx={{ mx: 4, mt: 1, fontSize: 14 }}>
              {subtitle || 'We have licensed insurance agents ready to help answer your questions. Select date and time that works best for you.'}
            </Typography>
            <Calendly
              {...rest}
              type={rest.type || CalendlyCallType.consultation}
              maxWidth={1000}
              onEventScheduled={(data) => {
                rest.onEventScheduled && rest.onEventScheduled(data);
                setEventScheduled(true);
              }}
            />
            <Box sx={{ m: 4 }}>
              <Typography sx={{ fontSize: 14, lineHeight: '24px' }}>
                {getDisclamers('SCHEDULE_A_CALL', props.maOrgCount && props.maPlansCount ? {maOrgCount: props.maOrgCount, maPlansCount: props.maPlansCount} : undefined, 'Continue', true)}
              </Typography>
            </Box>
          </Stack>
        </OverlayScrollbarsComponent>

      </Stack>
    </CRModal>
  );
};
